
































    import { Component } from "../../../Infrastructure/CorBase/CoreBase";
	import SettingListBase from "./SettingListBase";

	@Component
	export default class SettingUserList extends SettingListBase {
        
		queryBase2: any;
		private goBackPage(): void {
			this.goBackPageBase();
		}

		descriptionName() {
			var result = this.$t('setting.description');        
			return result;
		}

        private showDetail():boolean {
            return this.allowEditBase();
        }

		created() {
				this.initializeRightsLocal();
            this.createdBase();
			super.setAlertModalId('alertModalSettingList');
			super.created();
			super.setDetailName('SettingDetail');
			this.idSettingGroup = String(this.$route.query['idSettingGroup']);
            this.loadDefault(this.idSettingGroup);
		}

		loadFilters(value: any) { super.loadFilters(value); };
		detailClick(elementId: any) { super.detailClick(elementId); };


	};
